// extracted by mini-css-extract-plugin
module.exports =  {"platform-select":"platform-select--DKbXm","platformSelect":"platform-select--DKbXm","group":"group--ZWJKv","button":"button--fZnXg","icon":"icon--EJrcB"};